/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import H4 from 'UIComponents/elements/headings/H4';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIPopoverBody from 'UIComponents/tooltip/UIPopoverBody';
import UIPopoverCloseButton from 'UIComponents/tooltip/UIPopoverCloseButton';
import UIPopoverFooter from 'UIComponents/tooltip/UIPopoverFooter';
import UIPopoverHeader from 'UIComponents/tooltip/UIPopoverHeader';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import { usePromptDismissal, getDismissedAt } from 'find-and-filter-data/contextual-prompts/public';
import { SLAStatus } from 'find-and-filter-data/view-members-schema/public';
import { useRef } from 'react';
import styled from 'styled-components';
import { KnowledgeBaseLinks } from '../constants/ExternalLinks';
import PreviewCardSLAIcon from './PreviewCardSLAIcon';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INBOX_SLA_TOUR = 'INBOX_SLA_TOUR';
const slaBadgeIconSize = 14;
const slaBadgeIconPadding = 0.2;
const UIPopoverWithAnchoredHeader = styled(UIPopover).withConfig({
  displayName: "InboxSLAOnboardingModal__UIPopoverWithAnchoredHeader",
  componentId: "sc-9brlkb-0"
})(["top:-8px;.uiPopoverArrow{top:16px;}"]);
const InboxSLAOnboardingModal = ({
  children,
  onInboxSLATourOpen,
  onInboxSLATourClose
}) => {
  const hasTrackedInboxSLATourView = useRef(false);
  const {
    asyncPromptData,
    dismissPrompt
  } = usePromptDismissal(INBOX_SLA_TOUR);
  const allRequestsResolved = isSucceeded(asyncPromptData);
  const userPromptData = getData(asyncPromptData);
  if (!allRequestsResolved || !userPromptData) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  const shouldHideModal = getDismissedAt(userPromptData) > 0;
  if (shouldHideModal) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  if (!hasTrackedInboxSLATourView.current) {
    onInboxSLATourOpen();
    hasTrackedInboxSLATourView.current = true;
  }
  const handleClose = () => {
    onInboxSLATourClose();
    dismissPrompt();
  };
  return /*#__PURE__*/_jsx(UIPopoverWithAnchoredHeader, {
    open: true,
    showCloseButton: true,
    closeOnOutsideClick: false,
    use: "shepherd",
    placement: "right bottom",
    width: "400px",
    content: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(UIPopoverHeader, {
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.title"
          })
        }), /*#__PURE__*/_jsx(UIPopoverCloseButton, {
          popoverUse: "shepherd",
          onClick: handleClose
        })]
      }), /*#__PURE__*/_jsxs(UIPopoverBody, {
        children: [/*#__PURE__*/_jsx(UIFlex, {
          className: "m-bottom-8",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.description_top"
          })
        }), /*#__PURE__*/_jsx(UIFlex, {
          direction: "column",
          children: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs(UIFlex, {
              className: "m-bottom-5",
              children: [/*#__PURE__*/_jsx(PreviewCardSLAIcon, {
                status: SLAStatus.IN_SLA,
                className: "m-right-3",
                size: slaBadgeIconSize,
                padding: slaBadgeIconPadding
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.icon_description_sla_default"
              })]
            }), /*#__PURE__*/_jsxs(UIFlex, {
              className: "m-bottom-5",
              children: [/*#__PURE__*/_jsx(PreviewCardSLAIcon, {
                status: SLAStatus.SLA_WARNING,
                className: "m-right-3",
                size: slaBadgeIconSize,
                padding: slaBadgeIconPadding
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.icon_description_sla_warning"
              })]
            }), /*#__PURE__*/_jsxs(UIFlex, {
              className: "m-bottom-5",
              children: [/*#__PURE__*/_jsx(PreviewCardSLAIcon, {
                status: SLAStatus.BREACHED,
                className: "m-right-3",
                size: slaBadgeIconSize,
                padding: slaBadgeIconPadding
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.icon_description_sla_breached"
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(UIFlex, {
          className: "p-bottom-25",
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.description_jsx",
              elements: {
                UILink,
                br: 'br'
              },
              options: {
                href: KnowledgeBaseLinks.INBOX_SLA,
                external: true
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsx(UIPopoverFooter, {
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: handleClose,
          size: "small",
          style: {
            width: 'auto'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.gotIt"
          })
        })
      })]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
};
InboxSLAOnboardingModal.displayName = 'InboxSLAOnboardingModal';
export default InboxSLAOnboardingModal;